/* ALPHA&OMEGA theme — interactions: reveals, ticker, drawer cart, countdown, sliders */
(function () {
  'use strict';

  /* ---------- Scroll reveal ---------- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.15 });
  document.querySelectorAll('.reveal, .reveal-stagger').forEach(function (el) { io.observe(el); });

  /* ---------- Sticky header hide/reveal ---------- */
  var header = document.querySelector('.site-header');
  var lastY = 0;
  window.addEventListener('scroll', function () {
    var y = window.scrollY;
    if (header) header.classList.toggle('is-hidden', y > 240 && y > lastY);
    lastY = y;
    var bt = document.querySelector('.back-top');
    if (bt) bt.classList.toggle('is-visible', y > 600);
    var atc = document.querySelector('.sticky-atc');
    var form = document.querySelector('.product-form__buttons');
    if (atc && form) atc.classList.toggle('is-visible', form.getBoundingClientRect().bottom < 0);
  }, { passive: true });

  /* ---------- Animated counters ---------- */
  var counterIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      counterIO.unobserve(e.target);
      var el = e.target, target = parseFloat(el.dataset.count) || 0, suffix = el.dataset.suffix || '';
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / 1600, 1);
        p = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * p).toLocaleString() + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.4 });
  document.querySelectorAll('[data-count]').forEach(function (el) { counterIO.observe(el); });

  /* ---------- Countdown timers ---------- */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var end = new Date(el.dataset.countdown).getTime();
    if (isNaN(end)) return;
    function tick() {
      var d = Math.max(0, end - Date.now());
      var set = function (k, v) {
        var n = el.querySelector('[data-cd="' + k + '"]');
        if (n) n.textContent = String(v).padStart(2, '0');
      };
      set('days', Math.floor(d / 864e5));
      set('hours', Math.floor(d % 864e5 / 36e5));
      set('mins', Math.floor(d % 36e5 / 6e4));
      set('secs', Math.floor(d % 6e4 / 1e3));
    }
    tick(); setInterval(tick, 1000);
  });

  /* ---------- Mobile nav / back to top ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('.nav-toggle')) {
      var nav = document.querySelector('.site-nav');
      if (nav) nav.classList.toggle('is-open');
    }
    if (e.target.closest('.back-top')) window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  /* ---------- Product gallery + zoom ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.product__thumbs img');
    if (thumb) {
      var main = document.querySelector('.product__media img');
      if (main) main.src = thumb.dataset.full || thumb.src;
      document.querySelectorAll('.product__thumbs img').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      return;
    }
    var media = e.target.closest('.product__media');
    if (media) media.classList.toggle('is-zoomed');
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.qty button');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + (btn.dataset.dir === 'up' ? 1 : -1));
  });

  /* ---------- Variant selection ---------- */
  var pjson = document.querySelector('script[data-product-json]');
  if (pjson) {
    var data = JSON.parse(pjson.textContent);
    var scope = pjson.closest('form') || document;
    var selects = scope.querySelectorAll('.variant-selects select');
    var idInput = scope.querySelector('input[name="id"]');
    function money(cents) {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: data.currency || 'EUR' });
    }
    selects.forEach(function (s) {
      s.addEventListener('change', function () {
        var chosen = Array.prototype.map.call(selects, function (x) { return x.value; });
        var v = data.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === chosen[i]; });
        });
        if (!v) return;
        if (idInput) idInput.value = v.id;
        var priceEl = document.querySelector('[data-price]');
        if (priceEl) priceEl.textContent = money(v.price);
      });
    });
  }

  /* ---------- Cart drawer + AJAX add to cart ---------- */
  var drawer = document.getElementById('CartDrawer');
  var overlay = document.getElementById('DrawerOverlay');
  function openDrawer() { if (drawer) { drawer.classList.add('is-open'); overlay.classList.add('is-open'); } }
  window.AO_openCart = openDrawer;
  function closeDrawer() { if (drawer) { drawer.classList.remove('is-open'); overlay.classList.remove('is-open'); } }

  function renderCart(cart) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.add('is-bumped');
      setTimeout(function () { el.classList.remove('is-bumped'); }, 300);
    });
    if (!drawer) return;
    var body = drawer.querySelector('.cart-drawer__body');
    var totalEl = drawer.querySelector('[data-cart-total]');
    if (totalEl) totalEl.textContent = (cart.total_price / 100).toLocaleString(undefined, { style: 'currency', currency: cart.currency || 'EUR' });
    var threshold = parseInt(drawer.dataset.freeShipping || '0', 10) * 100;
    if (threshold > 0) {
      var fill = drawer.querySelector('.shipping-bar__fill');
      var label = drawer.querySelector('.shipping-bar__label');
      var pct = Math.min(100, cart.total_price / threshold * 100);
      if (fill) fill.style.width = pct + '%';
      if (label) {
        var remaining = Math.max(0, threshold - cart.total_price) / 100;
        label.innerHTML = remaining > 0
          ? 'Spend <strong>' + remaining.toLocaleString(undefined, { style: 'currency', currency: cart.currency || 'EUR' }) + '</strong> more for free shipping'
          : '<strong>You unlocked free shipping!</strong>';
      }
    }
    if (!body) return;
    if (!cart.items.length) { body.innerHTML = '<p style="padding-top:24px">Your cart is empty.</p>'; return; }
    body.innerHTML = cart.items.map(function (item) {
      var cur = cart.currency || 'EUR';
      var price = (item.final_line_price / 100).toLocaleString(undefined, { style: 'currency', currency: cur });
      var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_160x$1$2') + '" alt="">' : '<span></span>';
      var variant = (item.variant_title && item.variant_title !== 'Default Title') ? '<div class="cart-line__meta">' + item.variant_title + '</div>' : '';
      return '<div class="cart-line" data-key="' + item.key + '">' + img +
        '<div><div class="cart-line__title">' + item.product_title + '</div>' + variant +
        '<div class="cart-qty cart-qty--sm">' +
          '<button type="button" data-cart-change data-key="' + item.key + '" data-dir="-1" data-qty="' + item.quantity + '" aria-label="Decrease">−</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button type="button" data-cart-change data-key="' + item.key + '" data-dir="1" data-qty="' + item.quantity + '" aria-label="Increase">+</button>' +
        '</div>' +
        '<button class="cart-line__remove" data-cart-change data-key="' + item.key + '" data-dir="remove" data-qty="' + item.quantity + '">Remove</button></div>' +
        '<div>' + price + '</div></div>';
    }).join('');
  }

  window.AO_refreshCart = refreshCart;
  function refreshCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-cart]')) { e.preventDefault(); refreshCart(); openDrawer(); }
    if (e.target.closest('.cart-drawer__close') || e.target === overlay) closeDrawer();
    var chg = e.target.closest('[data-cart-change]');
    if (chg) {
      var key = chg.dataset.key;
      var q = parseInt(chg.dataset.qty, 10) || 0;
      var newQty = chg.dataset.dir === 'remove' ? 0 : Math.max(0, q + parseInt(chg.dataset.dir, 10));
      var inDrawer = !!chg.closest('#CartDrawer');
      chg.disabled = true;
      fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      }).then(function (r) { return r.json(); }).then(function (cart) {
        if (inDrawer) { renderCart(cart); } else { window.location.reload(); }
      });
    }
    var rm = e.target.closest('[data-remove-key]');
    if (rm) {
      fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: rm.dataset.removeKey, quantity: 0 })
      }).then(function (r) { return r.json(); }).then(renderCart);
    }
    var quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      var quickLabel = quick.textContent;
      quick.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(quick.dataset.quickAdd, 10), quantity: 1 })
      }).then(function (r) { return r.json(); }).then(function () {
        quick.textContent = 'Added ✓';
        setTimeout(function () { quick.textContent = quickLabel; }, 1800);
        refreshCart(); openDrawer();
      });
    }
  });

  // Intercept product form submit -> AJAX + drawer
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[name="add"]');
      var btnLabel = btn ? btn.textContent : '';
      if (btn) btn.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (btn) btn.textContent = 'Added ✓';
          setTimeout(function () { if (btn) btn.textContent = btnLabel; }, 1800);
          refreshCart(); openDrawer();
        });
    });
  });

  /* ---------- Hotspots (tap on mobile) ---------- */
  document.addEventListener('click', function (e) {
    var dot = e.target.closest('.hotspot__dot');
    document.querySelectorAll('.hotspot.is-open').forEach(function (h) {
      if (!dot || h !== dot.parentElement) h.classList.remove('is-open');
    });
    if (dot) dot.parentElement.classList.toggle('is-open');
  });

  /* ---------- Before/After slider ---------- */
  document.querySelectorAll('.ba').forEach(function (ba) {
    function setPos(clientX) {
      var r = ba.getBoundingClientRect();
      var pct = Math.min(100, Math.max(0, (clientX - r.left) / r.width * 100));
      ba.style.setProperty('--ba-pos', pct + '%');
    }
    var dragging = false;
    ba.addEventListener('pointerdown', function (e) { dragging = true; setPos(e.clientX); });
    window.addEventListener('pointermove', function (e) { if (dragging) setPos(e.clientX); });
    window.addEventListener('pointerup', function () { dragging = false; });
  });

  refreshCart();
})();

/* Loyalty: click a reward code to copy it */
document.addEventListener('click', function (e) {
  var code = e.target.closest('.loyalty-tier__code code');
  if (!code) return;
  navigator.clipboard && navigator.clipboard.writeText(code.textContent).then(function () {
    var orig = code.textContent;
    code.textContent = 'Copied ✓';
    setTimeout(function () { code.textContent = orig; }, 1400);
  });
});

/* ============================================================
   QUICK VIEW — fetch product JSON, render slide-out panel
   ============================================================ */
(function () {
  var qv = document.getElementById('QuickView');
  var qvOverlay = document.getElementById('QVOverlay');
  if (!qv) return;
  var body = qv.querySelector('.qv-drawer__body');
  var currency = qv.dataset.currency || 'EUR';

  function money(cents) {
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: currency });
  }
  function imgUrl(u, w) {
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function openQV() { qv.classList.add('is-open'); qvOverlay.classList.add('is-open'); qv.setAttribute('aria-hidden', 'false'); }
  function closeQV() { qv.classList.remove('is-open'); qvOverlay.classList.remove('is-open'); qv.setAttribute('aria-hidden', 'true'); }

  function optionNames(p) {
    return (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
  }

  function render(p) {
    var names = optionNames(p);
    var isSingle = p.variants.length === 1 && (p.variants[0].title === 'Default Title' || names.length === 0);

    // variant state
    var current = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];

    function priceHtml(v) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        return '<span class="money--sale">' + money(v.price) + '</span><s>' + money(v.compare_at_price) + '</s>';
      }
      return money(v.price);
    }

    // option selectors
    var optsHtml = '';
    if (!isSingle) {
      optsHtml = '<div class="variant-selects">' + names.map(function (name, i) {
        var values = [];
        p.variants.forEach(function (v) { var val = v.options[i]; if (values.indexOf(val) === -1) values.push(val); });
        return '<div><label>' + name + '</label><select data-qv-opt="' + i + '">' +
          values.map(function (val) {
            return '<option value="' + val.replace(/"/g, '&quot;') + '"' + (current.options[i] === val ? ' selected' : '') + '>' + val + '</option>';
          }).join('') + '</select></div>';
      }).join('') + '</div>';
    }

    // thumbnails
    var imgs = p.images || [];
    var thumbs = imgs.length > 1 ? '<div class="qv-thumbs">' + imgs.slice(0, 6).map(function (u, i) {
      return '<img src="' + imgUrl(u, 120) + '" data-full="' + imgUrl(u, 900) + '" class="' + (i === 0 ? 'is-active' : '') + '" alt="">';
    }).join('') + '</div>' : '';

    var mainImg = current.featured_image ? current.featured_image.src : (p.featured_image || imgs[0] || '');

    body.innerHTML =
      '<div class="qv-media"><img class="qv-main" src="' + imgUrl(mainImg, 900) + '" alt="' + (p.title || '') + '"></div>' +
      thumbs +
      '<div class="qv-info">' +
        (p.vendor ? '<div class="qv-vendor">' + p.vendor + '</div>' : '') +
        '<h2>' + p.title + '</h2>' +
        '<div class="qv-price" data-qv-price>' + priceHtml(current) + '</div>' +
        optsHtml +
        '<div class="product-form__buttons">' +
          '<div class="qty"><button type="button" data-dir="down" aria-label="Decrease">&minus;</button>' +
          '<input type="number" value="1" min="1" data-qv-qty aria-label="Quantity">' +
          '<button type="button" data-dir="up" aria-label="Increase">+</button></div>' +
          '<button type="button" class="btn btn--primary btn--block" data-qv-add ' + (current.available ? '' : 'disabled') + '>' +
            (current.available ? 'Add to cart' : 'Sold out') + '</button>' +
        '</div>' +
        (p.description ? '<div class="qv-desc">' + p.description + '</div>' : '') +
        '<a class="qv-full" href="/products/' + p.handle + '">View full details &rarr;</a>' +
      '</div>';

    function selectedVariant() {
      var selects = body.querySelectorAll('[data-qv-opt]');
      if (!selects.length) return current;
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      return p.variants.filter(function (v) {
        return chosen.every(function (val, i) { return v.options[i] === val; });
      })[0];
    }
    function update() {
      var v = selectedVariant();
      if (!v) return;
      current = v;
      body.querySelector('[data-qv-price]').innerHTML = priceHtml(v);
      var addBtn = body.querySelector('[data-qv-add]');
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (v.featured_image && v.featured_image.src) {
        body.querySelector('.qv-main').src = imgUrl(v.featured_image.src, 900);
      }
    }

    body.querySelectorAll('[data-qv-opt]').forEach(function (s) { s.addEventListener('change', update); });

    // thumbnail switch
    body.querySelectorAll('.qv-thumbs img').forEach(function (t) {
      t.addEventListener('click', function () {
        body.querySelector('.qv-main').src = t.dataset.full;
        body.querySelectorAll('.qv-thumbs img').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    // qty steppers (scoped)
    body.querySelectorAll('.qty button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = body.querySelector('[data-qv-qty]');
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + (btn.dataset.dir === 'up' ? 1 : -1));
      });
    });

    // add to cart
    body.querySelector('[data-qv-add]').addEventListener('click', function () {
      var v = selectedVariant() || current;
      if (!v || !v.available) return;
      var qty = parseInt(body.querySelector('[data-qv-qty]').value, 10) || 1;
      var btn = this; btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: v.id, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function () {
        closeQV();
        if (window.AO_refreshCart) window.AO_refreshCart();
        if (window.AO_openCart) window.AO_openCart();
      });
    });
  }

  // Trigger: any element with data-quick-view="{handle}"
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-quick-view]');
    if (t) {
      e.preventDefault();
      body.innerHTML = '<div class="qv-loading">Loading…</div>';
      openQV();
      fetch('/products/' + t.dataset.quickView + '.js')
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () { body.innerHTML = '<div class="qv-loading">Couldn\'t load this product.</div>'; });
      return;
    }
    if (e.target.closest('.qv-drawer__close') || e.target === qvOverlay) closeQV();
  });
})();

/* Launch page: copy discount code */
document.addEventListener('click', function (e) {
  var b = e.target.closest('.launch-code__copy');
  if (!b) return;
  var code = b.closest('.launch-code').dataset.copy || b.previousElementSibling.textContent;
  if (navigator.clipboard) navigator.clipboard.writeText(code.trim()).then(function () {
    b.textContent = 'Copied ✓'; b.classList.add('is-copied');
    setTimeout(function () { b.textContent = 'Copy'; b.classList.remove('is-copied'); }, 1600);
  });
});

/* Bundle: add all products at once */
document.addEventListener('click', function (e) {
  var b = e.target.closest('[data-bundle-add]');
  if (!b) return;
  var ids = (b.dataset.ids || '').split(',').filter(Boolean);
  if (!ids.length) return;
  var items = ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; });
  var label = b.textContent; b.textContent = 'Adding…';
  fetch('/cart/add.js', {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: items })
  }).then(function (r) { return r.json(); }).then(function () {
    b.textContent = 'Added ✓';
    setTimeout(function () { b.textContent = label; }, 1800);
    if (window.AO_refreshCart) window.AO_refreshCart();
    if (window.AO_openCart) window.AO_openCart();
  });
});

/* Product carousel arrows */
document.addEventListener('click', function (e) {
  var prev = e.target.closest('[data-carousel-prev]');
  var next = e.target.closest('[data-carousel-next]');
  if (!prev && !next) return;
  var sec = (prev || next).closest('.carousel-sec');
  var track = sec && sec.querySelector('[data-carousel-track]');
  if (!track) return;
  var amount = track.clientWidth * 0.8;
  track.scrollBy({ left: next ? amount : -amount, behavior: 'smooth' });
});

/* Launch page: reveal success/code after Shopify's post-redirect (?customer_posted=true) */
(function () {
  var card = document.querySelector('[data-launch]');
  if (!card) return;
  var params = new URLSearchParams(window.location.search);
  if (params.get('customer_posted') === 'true') {
    var formWrap = card.querySelector('[data-launch-form]');
    var success = card.querySelector('[data-launch-success]');
    if (formWrap) formWrap.hidden = true;
    if (success) {
      success.hidden = false;
      setTimeout(function () { success.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 150);
    }
  }
})();

/* Collection sort: native (reload) + custom strength (client-side) */
(function () {
  var sel = document.querySelector('[data-sort-by]');
  var grid = document.querySelector('[data-collection-grid]');
  if (!sel || !grid) return;
  sel.addEventListener('change', function () {
    var v = sel.value;
    if (v.indexOf('strength-') === 0) {
      var dir = v === 'strength-desc' ? -1 : 1;
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.card'));
      cards.sort(function (a, b) {
        return (parseFloat(a.dataset.strength || 0) - parseFloat(b.dataset.strength || 0)) * dir;
      });
      cards.forEach(function (c) { grid.appendChild(c); });
    } else {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', v);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    }
  });
})();

/* Cart page: discount code + price-capped upsell */
(function () {
  // Apply discount code via Shopify's discount link, return to cart
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-discount-form]');
    if (!form) return;
    e.preventDefault();
    var code = (form.querySelector('[data-discount-input]').value || '').trim();
    if (!code) return;
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
  });

  // Upsell: hide items pricier than the most expensive cart item + already-in-cart items
  var up = document.querySelector('.cart-upsell');
  if (up) {
    var max = parseInt(up.dataset.cartMax || '0', 10);
    var inCart = (up.dataset.cartVariants || '').split(',').filter(Boolean);
    var shown = 0;
    up.querySelectorAll('.cart-upsell__item').forEach(function (item) {
      var price = parseInt(item.dataset.price || '0', 10);
      var vid = item.dataset.variant;
      if ((max > 0 && price > max) || inCart.indexOf(vid) > -1 || shown >= 3) {
        item.style.display = 'none';
      } else { shown++; }
    });
    if (shown === 0) up.style.display = 'none';
  }

  // Upsell add -> add then reload cart page
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cart-upsell-add]');
    if (!b) return;
    b.textContent = 'Adding…'; b.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(b.dataset.id, 10), quantity: 1 })
    }).then(function () { window.location.reload(); });
  });
})();
